import React from 'react';
import { isNotEmpty, parseClasses } from '../../lib/ep';

const TimerBar = (props) => {
	const label = (isNotEmpty(props, 'children')) ? props.children : false;

	const classes = ['gui_progress'];
	let classname = parseClasses(classes.join(" "), props._class, 'progress');
	if(label !== false) classname += ' gui_flex_col';

	const is_countdown = props?.is_countdown ?? true;
	const initial = 100 * (props?.initial ?? ((is_countdown) ? 100 : 0));	// in % from 0 to 100

	const extra_class = ['bar_guide', 'gui_is_animated'];
	if(props.size != undefined) extra_class.push(props.size);

	const bar_class = ['bar', 'partial_animation'];
	if(is_countdown) bar_class.push('is_countdown');
	if(props.color != undefined) bar_class.push(props.color);
	if(props?.color_highlight ?? true) bar_class.push('with_color_highlight');

	const bar_styles = {};

	if(props.animation_duration != undefined) {
		bar_styles['--transition-duration'] = `${props.animation_duration}s`;
		bar_styles['--initial-width-state'] = `${initial}%`;
		bar_styles['--initial-opacity-state'] = `${1 - initial / 100}`;
	}

	return (
		<div class={classname}>
			{(label !== false) && (
				<p dangerouslySetInnerHTML={{ __html:label }} />
			)}

			<div class={extra_class.join(" ")}>
				<div
					class={bar_class.join(" ")}
					style={bar_styles}
				/>
			</div>
		</div>
	);
}

export default TimerBar;